export const HEADER_HEIGHT = 88;
export const LAYERS_PANEL_WIDTH = 300;



// WEBPACK FOOTER //
// ./src/constants/layout.js